// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"3327bd11","128":"b89e1718","221":"defa3247","241":"7ba3dc7f","500":"3327bd11","608":"bccaea12","817":"c3b41c15"}[chunkId] + ".chunk.css";
};